import XSS from 'xss';
import React from 'react';
import _ from 'lodash';

const sanitizeUserInput = variables => {
    return _.zipObject(
        _.keys(variables),
        _.values(variables).map(v => (typeof v == 'number' ? v : XSS(v)))
    );
};

const createDangerouslySetReactElement = html => {
    return React.createElement('span', {
        dangerouslySetInnerHTML: { __html: html }
    });
};

I18n.htmlSafe = (key, variables) => {
    let sanitizedVariables = sanitizeUserInput(variables);
    let translatedString = I18n.t(key, sanitizedVariables);
    return createDangerouslySetReactElement(translatedString);
};
